import { defineStore } from "pinia";
import { reactive } from "vue";

export const useConstitucionSociedadesStore = defineStore(
  "constitucionSociedades",
  () => {
    const constitutiva = reactive({
      isLoaded: false, // Already loaded to persistent storage

      id: null,
      cambios: [],

      disabled: false,
      disabledComplementa: false,
      disabledDocumentos: false,
      disabledCita: false,

      validoGenerales: false,
      validoCapital: false,
      validoOrganos: false,
      validoRepresentantes: false,
      validoCapitulos: false,
      validoEntidad: false,
      validoCotizacion: false,
      validoComplementa: false,
      validoEntrega: false,
      validoDocListo: false,
      validoCita: false,

      accion: "edit",

      clientes_id: null,
      tipo_societario: null,
      denominaciones_sociales_1: null,
      denominaciones_sociales_2: null,
      denominaciones_sociales_3: null,
      tiene_capital_variable: true,
      autoriza_cd_denominacion: null,
      objeto_social: null,
      objeto_social_otro: null,
      objeto_actividad: null,

      capital_fijo: null,
      capital_variable: null,
      accionistas: [],
      capital_extranjero: null,

      tipo_administracion: null,
      administradores: [],
      presidente_voto: null,
      vigilancia: [],

      apoderados: [],

      link_calendario: null,
      corredurias_id: null,
      firma_oficina: true,
      selectedEntidad: null,
      selectedMunicipio: null,
      selectedCorreduria: null,
      optionsEntidades: [],
      optionsMunicipios: [],
      optionsColonias: [],

      reglas_control: null,
      reglas_asambleas: null,

      titulos_acciones: null,
      libros_corporativos: null,
      cotizaciones_id: null,

      cupones_id: null,
      cupones_referencia_id: null,
      precio_total: 0,
      pagado: null,
      folio_transaccion: null,
      gastos: [],
      subtotal_titulos: 0,
      subtotal_libros: 0,

      documentos: [],
      formularios: [],
      cotizacion: {
        conceptos: {
          accionista_pf: null,
          accionista_pm: null,
          administrador: null,
          comisario: null,
          apoderado: null,
          capital_extranjero: null,
          titulos_acciones: null,
          libros_corporativos: null,
          reglas_control: null,
          reglas_asambleas: null,
          firma_fuera: null,
          exclusion_accionistas: null,
          cupon: null,
        },
      },

      direccion_firma: null,
      fecha_firma: null,
      clausula_extranjeros: null,

      acciones_valor_nominal: true,
      exclusion_accionistas: null,

      domicilios: [],
      pais: null,
      entidadDomicilio: null,
      municipioDomicilio: null,

      beneficiario_pld: null,
      beneficiario_cff: null,
      folio: null,
      nombre_beneficiario_pld: null,
      nombre_beneficiario_cff: null,
    });

    function resetConstitutiva() {
      Object.assign(constitutiva, {
        isLoaded: false,
        id: null,
        cambios: [],
        disabled: false,
        disabledComplementa: false,
        disabledDocumentos: false,
        disabledCita: false,

        validoGenerales: false,
        validoCapital: false,
        validoOrganos: false,
        validoRepresentantes: false,
        validoCapitulos: false,
        validoEntidad: false,
        validoCotizacion: false,
        validoComplementa: false,
        validoEntrega: false,
        validoDocListo: false,
        validoCita: false,

        accion: "edit",

        clientes_id: null,
        tipo_societario: null,
        denominaciones_sociales_1: null,
        denominaciones_sociales_2: null,
        denominaciones_sociales_3: null,
        tiene_capital_variable: true,
        autoriza_cd_denominacion: null,
        objeto_social: null,
        objeto_social_otro: null,
        objeto_actividad: null,

        capital_fijo: null,
        capital_variable: null,
        accionistas: [],
        capital_extranjero: null,

        tipo_administracion: null,
        administradores: [],
        presidente_voto: null,
        vigilancia: [],

        apoderados: [],

        link_calendario: null,
        corredurias_id: null,
        firma_oficina: true,
        selectedEntidad: null,
        selectedMunicipio: null,
        selectedCorreduria: null,
        optionsEntidades: [],
        optionsMunicipios: [],
        optionsColonias: [],

        reglas_control: null,
        reglas_asambleas: null,

        titulos_acciones: null,
        libros_corporativos: null,
        cotizaciones_id: null,

        cupones_id: null,
        cupones_referencia_id: null,
        precio_total: 0,
        pagado: null,
        folio_transaccion: null,
        gastos: [],
        subtotal_titulos: 0,
        subtotal_libros: 0,

        documentos: [],
        formularios: [],
        cotizacion: {
          conceptos: {
            accionista_pf: null,
            accionista_pm: null,
            administrador: null,
            comisario: null,
            apoderado: null,
            capital_extranjero: null,
            titulos_acciones: null,
            libros_corporativos: null,
            reglas_control: null,
            reglas_asambleas: null,
            firma_fuera: null,
            exclusion_accionistas: null,
            cupon: null,
          },
        },

        direccion_firma: null,
        fecha_firma: null,
        clausula_extranjeros: null,

        acciones_valor_nominal: true,
        exclusion_accionistas: null,

        domicilios: [],
        pais: null,
        entidadDomicilio: null,
        municipioDomicilio: null,

        beneficiario_pld: null,
        beneficiario_cff: null,
        folio: null,
        nombre_beneficiario_pld: null,
        nombre_beneficiario_cff: null,
      });
    }

    function deleteStore() {
      resetConstitutiva();
      localStorage.removeItem("constitucionSociedades");
    }

    return {
      constitutiva,
      resetConstitutiva,
      deleteStore,
    };
  },
  {
    persist: true,
  },
);
